<template>
    <mds-dialog v-model="showDialog" action-required title="" @mds-dialog-dismissed="dismissAction">
        {{ getUILabel(headerDialogConfig.mainText) }}
        <template v-slot:mds-dialog-supplemental-content>
            <mds-form v-if="hasInput">
                <mds-fieldset>
                    <mds-input
                        hidden-label
                        :error-text="[currentErrorText]"
                        :error="hasError"
                        label="Input name"
                        v-model="dialogInput"
                        @keyup="debouncedChange()"
                    ></mds-input>
                </mds-fieldset>
            </mds-form>
        </template>
        <template v-slot:mds-dialog-actions-right>
            <mds-button-container right-aligned>
                <mds-button variation="secondary" @click="dismissAction"> {{ getUILabel(headerDialogConfig.dismissLabel) }} </mds-button>
                <mds-button variation="primary" @click="executeAction" :disabled="fieldDisabled">
                    {{ getUILabel(headerDialogConfig.executeLabel) }}
                </mds-button>
            </mds-button-container>
        </template>
    </mds-dialog>
</template>

<script>
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import HypoWorkflowMixin from "@/mixins/HypoWorkflowMixin";
import MdsForm from "@mds/form";
import MdsFieldset from "@mds/fieldset";
import MdsInput from "@mds/input";
import { MdsButton, MdsButtonContainer } from "@mds/button";
import MdsDialog from "@mds/dialog";
import { debounce } from "lodash";
export default {
    name: "header-dialog",
    mixins: [HypoWorkflowMixin, MwcSharedMixin],
    components: { MdsDialog, MdsFieldset, MdsForm, MdsButtonContainer, MdsButton, MdsInput },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        headerDialogConfig: {
            type: [Object],
            default: () => {
                return {
                    mainText: "home_delete_dialog_title",
                    dialogType: "hypo", // "hypo", "portfolio"
                    action: "delete", // "rename", "delete"
                    dismissLabel: "common_cancel",
                    executeLabel: "common_delete",
                    portfolioIndex: null
                };
            }
        }
    },
    data() {
        return {
            showDialog: false,
            dialogInput: "",
            hasError: false,
            debouncedChange: debounce(() => this.checkHypoNames(), 500),
            currentErrorText: ""
        };
    },
    mounted() {
        this.showDialog = this.show;
        this.dialogInput = this.currentInput;
    },
    computed: {
        currentInput() {
            let hypoName, portfolioName;
            if (this.headerDialogConfig.dialogType === "hypo") {
                hypoName = this.$store.getters["hypo/getName"] === "Untitled" ? "" : this.$store.getters["hypo/getName"];
            } else {
                portfolioName = this.$store.state.investments.portfolioList[this.headerDialogConfig.portfolioIndex || 0].name;
            }
            return this.headerDialogConfig.dialogType === "hypo" ? hypoName : portfolioName;
        },
        hasInput() {
            return this.headerDialogConfig.action === "rename";
        },
        fieldDisabled() {
            return (this.dialogInput === "" || this.hasError) && this.hasInput;
        }
    },
    methods: {
        setErrorText() {
            this.currentErrorText =
                this.dialogInput.length < 100 ? this.getUILabel("common_rename_hypo_dialog_error") : this.getUILabel("common_length_hypo_dialog_error");
        },
        checkHypoNames() {
            const validName = this.dialogInput === this.currentInput ? true : this.checkAvailableName(this.dialogInput.trim());
            this.setErrorText();
            this.hasError = !(this.hasInput && validName) || !validName || this.dialogInput === "";
        },
        dismissAction() {
            this.showDialog = false;
            this.$emit("dialog-close");
        },
        executeAction() {
            const { action } = this.headerDialogConfig;
            const actions = {
                rename: () => {
                    this.renameAction(this.headerDialogConfig.dialogType);
                },
                delete: () => {
                    this.deleteAction(this.headerDialogConfig.dialogType);
                },
                default: () => {
                    this.$emit("dialog-main-action");
                }
            };
            const execute = actions[action] || actions["default"];
            execute();
        },
        renameAction(type) {
            if (type === "hypo") {
                this.hasError = false;
                this.checkHypoNames();
                const validName = this.dialogInput !== "" && this.dialogInput.length < 100 && !this.hasError;
                if (this.hasInput && validName) {
                    this.renameHypoFile(this.dialogInput);
                    this.hasError = false;
                    this.dismissAction();
                } else if (!validName) {
                    this.setErrorText();
                    this.hasError = true;
                }
            } else {
                this.renamePortfolio(this.dialogInput, this.headerDialogConfig.portfolioIndex || 0);
                this.dismissAction();
            }
        },
        deleteAction() {
            this.deleteHypoFile();
        }
    },
    watch: {
        show: {
            handler(newVal) {
                this.showDialog = newVal;
            }
        },
        headerDialogConfig: {
            handler(newVal) {
                this.dialogConfig = newVal;
                this.dialogInput = this.currentInput;
            }
        }
    }
};
</script>
